/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let botTicketApiUrl = root.botTicketApiUrl.link;
let tukivitaFeedbacksApiUrl = root.tukivitaFeedbacksApiUrl.link;

export default {
  state: {
    botTicketListState:{},
    ticketChatListState:{},
    tukivitaFeedbacksState:{}
    },
  mutations: {
    botTicketListMutation(state, value) {
      Vue.set(state, 'botTicketListState', value);
    },
    ticketChatListMutation(state, value) {
      Vue.set(state, 'ticketChatListState', value);
    },
    tukivitaFeedbacksMutations(state, value) {
      Vue.set(state, 'tukivitaFeedbacksState', value);
    },
  },
  actions: {
    tukivitaFeedbacksListAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.get(tukivitaFeedbacksApiUrl).then((response) => {
            context.commit('tukivitaFeedbacksMutations', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    ticketChatListAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.get(botTicketApiUrl + '?is_active=true').then((response) => {
            context.commit('ticketChatListMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    botTicketListAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.get(botTicketApiUrl + '?status=' + payload.filter).then((response) => {
            context.commit('botTicketListMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    botTicketCloseAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.post(botTicketApiUrl + payload.ticketId + "/close/").then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    botMessagesListAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.get(botTicketApiUrl + payload.id + '/messages/').then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
    botTicketListGetters: state => state.botTicketListState,
    ticketChatListGetters: state => state.ticketChatListState,
    tukivitaFeedbacksGetters: state => state.tukivitaFeedbacksState,
  }
}